import React from 'react';
import { BsTwitter, BsGithub, BsLinkedin } from 'react-icons/bs';
import { SiLeetcode, SiCodingninjas } from 'react-icons/si';



const SocialMedia = () => {
  return (
    <div className='app__social'>
        <div>
            <a href='https://www.linkedin.com/in/abhay-shah07/'>
            <BsLinkedin />
            </a>
        </div>
        <div>
            <a href='https://github.com/abhayshah3017'>
            <BsGithub /> 
            </a>
        </div>
        <div>
            <a href='https://leetcode.com/abhayshah3017/'>
            <SiLeetcode /> 
            </a>    
        </div>
        <div>
            <a href='https://www.codingninjas.com/codestudio/profile/AbhayShah'>
            <SiCodingninjas /> 
            </a>
        </div>
        <div>
            <a href='https://twitter.com/AbhaySh68239513'>
            <BsTwitter /> 
            </a>
        </div>

    </div>
  )
}

export default SocialMedia